import React, { useEffect, useState } from 'react';
import Modernbanc, { OutputElement, OutputElementOptions } from '../../lib';
import { API_KEY } from '../constants';
import S, { Chevron, Header, Main, ResultComponent, Row } from './styles';

const Output = () => {
  const [mdb] = useState(new Modernbanc(API_KEY));
  const [loading, setLoading] = useState(true);
  const [secret_id, setSecretId] = useState<string>('SECRET_FEB24_DNkteVXb397PLimvfI8');
  const [reveal, setReveal] = useState<boolean>(false);
  const [element, setElement] = useState<OutputElement>();
  const [error, setError] = useState<boolean>(false);

  const output_props: OutputElementOptions = {
    type: 'output',
    id: 'cvc_output',
    css: 'border: 1px solid #e2e2e2; color: black; padding: 4px 5px;border-radius: 4px;',
    secret_id,
    placeholder: '***',
    google_font_url: 'https://fonts.googleapis.com/css2?family=Inter:wght@400;500&display=swap',
  };

  const show = async (e: React.FormEvent<HTMLButtonElement>) => {
    e.preventDefault();
    setLoading(true);
    const response = await element?.showSecretValue();
    if (response?.is_error) {
      console.error(response.error);
      setLoading(false);
      setError(true);
      return;
    }

    // Component has now revealed the secret value in your app.
    setLoading(false);
    setReveal(true);
  };

  useEffect(() => {
    const output_element = mdb.addElement(output_props);

    if (output_element) {
      output_element.mount(`#${output_props.id}_container`);
      output_element.on('ready', () => {
        setLoading(false);
      });
      setElement(output_element);
    }

    return () => {
      mdb.element_map.delete(output_element.id);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <S.Container>
      <S.Label>Reveal Data</S.Label>
      <S.Form>
        <Header>
          Check your card details <Chevron />
        </Header>

        <Main data-show={!loading && !error}>
          <Row>
            <S.SecretInput
              spellCheck={false}
              placeholder={'Enter secret id to reveal'}
              type="text"
              value={secret_id}
              onChange={(e) => {
                setSecretId(e.target.value);
                element?.setOptions({ type: 'output', id: output_props.id, secret_id: e.target.value });
              }}
            />
          </Row>
          <Row>
            <S.ElementContainer id={`${output_props.id}_container`} />
          </Row>
          {!reveal ? (
            <S.Button disabled={!secret_id} onClick={show}>
              Show
            </S.Button>
          ) : (
            <span style={{ marginBottom: '20px' }} />
          )}
        </Main>
        <ResultComponent loading={loading} error={error} />
      </S.Form>
    </S.Container>
  );
};

export default Output;
